import React from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const EmailSettingsCard = ({ formData, setFormData, settings, showApiKey, setShowApiKey }) => (
  <Card>
    <CardHeader>
      <CardTitle>Configuração de Email (SendGrid)</CardTitle>
      <CardDescription>
        Opcional — deixe em branco para usar a chave global da plataforma. Configure aqui apenas se quiser usar a sua própria conta SendGrid.
      </CardDescription>
    </CardHeader>
    <CardContent className="space-y-4">
      <div>
        <Label htmlFor="sendgrid_api_key">API Key do SendGrid</Label>
        <div className="flex gap-2">
          <Input
            id="sendgrid_api_key"
            type={showApiKey ? 'text' : 'password'}
            value={formData.sendgrid_api_key}
            onChange={(e) => setFormData(prev => ({ ...prev, sendgrid_api_key: e.target.value }))}
            placeholder={settings?.sendgrid_api_key_masked || 'Cole a sua API key aqui...'}
            className="flex-1"
            data-testid="sendgrid-api-key-input"
          />
          <Button
            variant="outline"
            size="icon"
            onClick={() => setShowApiKey(!showApiKey)}
          >
            {showApiKey ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
          </Button>
        </div>
        <p className="text-sm text-slate-500 mt-1">
          {settings?.sendgrid_api_key_masked
            ? `Configurado: ${settings.sendgrid_api_key_masked}`
            : 'A usar a chave global da plataforma. Obtenha uma chave própria em app.sendgrid.com'}
        </p>
      </div>

      <div>
        <Label htmlFor="sender_email">Email do Remetente</Label>
        <Input
          id="sender_email"
          type="email"
          value={formData.sender_email}
          onChange={(e) => setFormData(prev => ({ ...prev, sender_email: e.target.value }))}
          placeholder="noreply@empresa.com"
          data-testid="sender-email-input"
        />
        <p className="text-sm text-slate-500 mt-1">
          Use um email verificado no SendGrid (Single Sender ou Domain Authentication)
        </p>
      </div>
    </CardContent>
  </Card>
);
